

import { gsap } from 'gsap'
import { Draggable } from 'gsap/Draggable'
import enquire from 'enquire.js'

gsap.registerPlugin(Draggable)

const timelineSlider = () => {
  const timeline = Array.from(document.querySelectorAll('.js-timeline'))
  timeline.forEach(elem => {
    const timelineContainer = elem.querySelector('.js-timeline-container')
    let timelineContainerHeight = timelineContainer.getBoundingClientRect().height

    const timelineColumn = Array.from(elem.querySelectorAll('.js-timeline-column'))
    let timelineColumnWidth = timelineColumn[0].getBoundingClientRect().width
    const timelineColumnCount = timelineColumn.length
    let timelineContainerWidth = timelineColumnWidth * timelineColumnCount

    const rangeContainer = elem.querySelector('.js-timeline-range-container')
    const knob = elem.querySelector('.js-timeline-knob')
    const knobHandle = elem.querySelector('.js-timeline-knob-handle')
    const knobHandleWidth = knobHandle.getBoundingClientRect().width

    let draggableY
    let draggableX

    let timelineY
    let mapperY
    let rangeRectY = rangeContainer.offsetHeight

    let timelineX
    let mapperX
    let rangeRectX = rangeContainer.offsetWidth

    timelineY = gsap.timeline({ paused: true })
    timelineX = gsap.timeline({ paused: true })

    enquire
      .register('screen and (min-width: 768px)', {
        match: function() {
          draggableY = new Draggable(knob, {
            type: "y",
            bounds: rangeContainer,
            lockAxis: true,
            edgeResistance: 1,
            overshootTolerance: 0,
            onDrag: updateRangeY
          })

          updateMapperY()
          window.addEventListener('resize', updateMapperY)
        },
        unmatch: function() {
          draggableY.kill()
          gsap.set([timelineContainer, knob], { clearProps: 'all' })
          window.removeEventListener('resize', updateMapperY)
        },
      })
      .register('screen and (max-width: 767px)', {
        match: () => {
          draggableX = new Draggable(knob, {
            type: "x",
            bounds: rangeContainer,
            lockAxis: true,
            edgeResistance: 1,
            overshootTolerance: 0,
            onDrag: updateRangeX
          })

          updateMapperX()
          window.addEventListener('resize', updateMapperX)
        },
        unmatch: () => {
          draggableX.kill()
          gsap.set([timelineContainer, knob], { clearProps: 'all' })
          window.removeEventListener('resize', updateMapperX)
        },
      })

    function updateMapperY() {
      rangeRectY = rangeContainer.offsetHeight
      mapperY = gsap.utils.mapRange(0, rangeRectY, 0, 1)
      timelineContainerHeight = timelineContainer.getBoundingClientRect().height
      timelineY.progress(0).clear()
      timelineY.to(timelineContainer, {
        y: -(timelineContainerHeight - rangeRectY - knobHandleWidth),
        duration: 1
      })
      updateRangeY()
    }

    function updateMapperX() {
      rangeRectX = rangeContainer.offsetWidth
      mapperX = gsap.utils.mapRange(0, rangeRectX, 0, 1)
      timelineColumnWidth = timelineColumn[0].getBoundingClientRect().width
      timelineContainerWidth = timelineColumnWidth * timelineColumnCount
      timelineX.progress(0).clear()
      timelineX.to(timelineContainer, {
        x: -(timelineContainerWidth - rangeRectX - knobHandleWidth - 6),
        duration: 1
      })
      updateRangeX()
    }

    function updateRangeY() {
      timelineY.progress(mapperY(draggableY.y))
    }

    function updateRangeX() {
      timelineX.progress(mapperX(draggableX.x))
    }

    knobHandle.addEventListener('pointerdown', () => {
      gsap.to(knobHandle, { scale: 1.5 })
    })

    knobHandle.addEventListener('pointerup', () => {
      gsap.to(knobHandle, { scale: 1 })
    })

    rangeContainer.addEventListener('mouseleave', () => {
      gsap.to(knobHandle, { scale: 1 })
    })
  })
}
timelineSlider()
